import React from 'react'

const Button = ({color, text}) => {
  return (
    <button style={{backgroundColor: `${color}`}}>{text}</button>
  )
}

export default Button